"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getVoucherModalContent = void 0;
var mobx_react_1 = require("mobx-react");
var React = require("react");
var lang_1 = require("utils/lang");
var Toast_1 = require("../../ezUI/Toast");
var styles = require("./index.scss");
var store_1 = require("./store");
var VoucherOne_1 = require("./VoucherOne");
var VoucherThree_1 = require("./VoucherThree");
var VoucherTwo_1 = require("./VoucherTwo");
var array_1 = require("../../../utils/array");
var getLang = lang_1.getEzbuyLang();
var MagicVoucher = (function (_super) {
    __extends(MagicVoucher, _super);
    function MagicVoucher(props) {
        var _this = _super.call(this, props) || this;
        _this.onClaimVoucher = function (voucher) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (voucher.voucherState) {
                    case store_1.VoucherState.ComingSoon:
                        this.store.setWarnMsg(getLang("Voucher coming soon"));
                        break;
                    case store_1.VoucherState.canReceive:
                        this.store.claimVoucher(voucher, this.props.onLogin);
                        break;
                    case store_1.VoucherState.Received:
                        if (voucher.info.link) {
                            window.open(voucher.info.link);
                            return [2];
                        }
                        if (voucher.countPerCustomer === 0) {
                            this.store.setWarnMsg(getLang("Voucher has been Fully Redeemed"));
                        }
                        else {
                            this.store.setWarnMsg(getLang("You have reached the voucher redemption limit"));
                        }
                        break;
                    case store_1.VoucherState.RanOut:
                        this.store.setWarnMsg(getLang("Voucher has been Fully Redeemed"));
                        break;
                    case store_1.VoucherState.Expired:
                        this.store.setWarnMsg(getLang("Voucher has expired"));
                        break;
                    default:
                }
                return [2];
            });
        }); };
        _this.VoucherHeight = function (columnSize, length) {
            var bannerH = "initial";
            switch (columnSize) {
                case 1:
                    bannerH = 182 * length + 12 + "px";
                    break;
                case 2:
                    bannerH = "169px";
                    break;
                case 3:
                    bannerH = "219px";
                    break;
                default:
                    break;
            }
            return bannerH;
        };
        _this.state = {};
        _this.store = new store_1.default(props.vouchers, props.modId);
        return _this;
    }
    MagicVoucher.prototype.render = function () {
        var _this = this;
        var _a = this.props, id = _a.id, bgColor = _a.bgColor, columnSize = _a.columnSize;
        var _b = this.store, vouchers = _b.vouchers, warnMsg = _b.warnMsg;
        var Voucher;
        var voucherClass = "";
        switch (columnSize) {
            case 1:
                Voucher = VoucherOne_1.default;
                voucherClass = styles.splitOne;
                break;
            case 2:
                Voucher = VoucherTwo_1.default;
                voucherClass = styles.splitTwo;
                break;
            case 3:
                Voucher = VoucherThree_1.default;
                voucherClass = styles.splitThree;
                break;
            default:
                return null;
        }
        var hasValidVoucher = array_1.isNotBlankArray(vouchers);
        if (hasValidVoucher) {
            return (React.createElement("div", { id: id, className: styles.voucherContainer, style: { height: this.VoucherHeight(columnSize, vouchers.length) } },
                React.createElement("div", { className: voucherClass }, vouchers.map(function (item, index) { return (React.createElement(Voucher, { key: index, voucher: item, bgColor: bgColor, ui: item.ui, onClaim: _this.onClaimVoucher })); })),
                warnMsg && React.createElement(Toast_1.default, { message: warnMsg })));
        }
        return null;
    };
    MagicVoucher = __decorate([
        mobx_react_1.observer
    ], MagicVoucher);
    return MagicVoucher;
}(React.Component));
exports.default = MagicVoucher;
function getVoucherModalContent(voucher) {
    var getDate = function (startSpan, endSpan) {
        var startDate = new Date(parseInt(startSpan, 10) * 1000).toLocaleDateString();
        var endDate = new Date(parseInt(endSpan, 10) * 1000).toLocaleDateString();
        return startDate + "-" + endDate;
    };
    return (React.createElement("div", { className: styles.modalContainer },
        React.createElement("h1", { className: styles.modalHeader }, getLang("Congratulation! You have got")),
        React.createElement("img", { src: voucher.info.img, alt: "" }),
        React.createElement("p", { className: styles.subscript },
            getLang("Expired Date"),
            ": ",
            getDate(voucher.startDate, voucher.endDate)),
        React.createElement("p", { className: styles.description }, getLang("Use this voucher upon check out to enjoy great discounts!"))));
}
exports.getVoucherModalContent = getVoucherModalContent;
